import React from 'react';

import { KeyValueLabel } from '@/components/molecules/key-value-label';
import { EnhancedReading } from '@/features/equipment-browser/subscriptions/use-get-readings-values';
import { getSourceUnits } from '@/features/equipment-browser/utils';
import { formatUnits } from '@/helpers/unit-formatter/unit-formatter';

import { getMetricValueRenderer } from './equipment-details-metric-renderer';

interface EquipmentDetailsMetricLabelProps {
  reading: EnhancedReading;
}

export const EquipmentDetailsMetricLabel = ({
  reading,
}: EquipmentDetailsMetricLabelProps): React.ReactNode => {
  // If reading.units is not configured, assume the value is already in displayUnits
  const sourceUnits = getSourceUnits(reading);
  const formattedLabels = formatUnits(
    { value: reading?.value, units: sourceUnits },
    reading?.displayUnits
  );

  // Get the appropriate renderer and render the value
  const renderValue = getMetricValueRenderer(reading.displayUnits);
  const value = renderValue({ reading, formattedLabels });

  return (
    <KeyValueLabel
      keyText={reading?.label ?? ''}
      value={() => value}
      valueTitle={formattedLabels.valueUnitsLabel}
      variant="block"
      className="min-w-0 max-w-full"
    />
  );
};
